"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import Separator from "@/components/separator";

export default function PricingCTA() {
  return (
    <section className="relative">
      <Separator />
      <div className="container mx-auto px-4 sm:px-6 mt-12 mb-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">
            Start Your AI-Powered Trading Journey Today
          </h2>
          <p className="text-lg md:text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
            Join the waitlist and be among the first to experience FynWise
          </p>
          <div className="flex justify-center items-center">
            <Link
              href="/auth/signup"
              className="w-[150px] bg-white h-[50px] inline-flex items-center justify-center rounded-xl cursor-pointer relative overflow-hidden transition-all duration-500 ease-in-out shadow-md hover:scale-105 hover:shadow-lg before:absolute before:top-0 before:-left-full before:w-full before:h-full before:bg-black before:transition-all before:duration-500 before:ease-in-out before:z-[-1] before:rounded-xl hover:before:left-0 text-black hover:text-white group"
            >
              <span className="inline-flex items-center justify-center">
                Get Started
                <svg
                  className="ml-2 w-4 h-4 text-black group-hover:text-white transition-colors duration-200"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}